import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';
import { PrintServices } from '../../services/printServices';
import { StockServices } from '../../stock/services';
import { TakeawayServices } from '../services';

/**
 * Generated class for the TpvTicketSelectedPayIndvPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-order-invite-discount-element',
  templateUrl: 'takeaway-order-invite-discount-element.html',
})
export class TakeawayOrderInviteDiscountElementPage {

  ticket_elements: any = Array();
  type: any;
  percentage: number = 0;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals,
    public printServices: PrintServices,
    public stockServices: StockServices) {
    this.takeawayServices.ticket_print = 'indv';
    this.type = this.navParams.get('type');
  }

  async ionViewDidLoad() {
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //objectToArray ticket_elements
    this.ticket_elements = this.globals.objectToArray(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.list);
  }

  insertArraySelected(element, index) {
    this.changeState(index, 'selected');
  }

  changeState(index, state) {
    this.ticket_elements[index]['state_indv'] = state;
  }

  async invite() {
    for (let element of this.ticket_elements) {
      if (element.state_indv == 'selected') {
        var name = 'INV. - ' + element.name + ' - invitado';
        element.state_indv = 'invite'
        this.takeawayServices.insertTableDiscount(name, -Math.abs(element.price), element.delete, true, 'invite', '', 'invite', element.price, element.tax);
      }
    }
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //listSelectedTicket
    this.takeawayServices.selected_list = this.takeawayServices.listSelectedTicket('name', this.globals.objectToArray(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.list))
    this.navCtrl.pop();
    this.navCtrl.pop();
  }

  ionViewWillUnload() {
    this.takeawayServices.cleanTicketIndvSelectedArrayInvite();
    this.takeawayServices.ticket_print = 'normal';
  }

  delete(index) {
    this.changeState(index, '');
  }

  applyDiscountPercentage(number) {
    this.percentage = number;
  }

  applyDiscount() {
    this.calculate();
  }

  async calculate() {
    for (let element of this.ticket_elements) {
      if (element.state_indv == 'selected') {


        var total = element.price;
        var discounted = (total * this.percentage) / 100;

        var name = this.percentage + '% DES. - ' + element.name + ' - descuento línea';
        element.state_indv = 'linediscount';

        this.takeawayServices.insertTableDiscount(name, -Math.abs(discounted), element.delete, element.count, 'linediscount', '', 'linediscount', discounted, element.tax);
      }
    }
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //listSelectedTicket
    this.takeawayServices.selected_list = this.takeawayServices.listSelectedTicket('name', this.globals.objectToArray(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.list))
    this.navCtrl.pop();
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order-invite-discount-element/takeaway-order-invite-discount-element.ts